<template>
  <div class="station-banner-wrapper">
    <div
      v-if="isCurrentSeasonSummer && state.doesStationPdfExists"
      class="col-12 pb-5"
    >
      <template v-if="isTabletOrDesktopScreenSize">
        <a :href="state.pdfLink" target="_blank">
          <img
            :src="data.summerBannerDesktopImg"
            loading="lazy"
            class="w-100"
          />
        </a>
      </template>
      <template v-if="isMobileScreenSize">
        <a :href="state.pdfLink" target="_blank">
          <img :src="data.summerBannerMobileImg" loading="lazy" class="w-100" />
        </a>
      </template>
    </div>
    <div
      v-if="!isCurrentSeasonSummer && state.doesStationPdfExists"
      class="col-12 pb-5"
    >
      <template v-if="isTabletOrDesktopScreenSize">
        <a :href="state.pdfLink" target="_blank">
          <img
            :src="data.winterBannerDesktopImg"
            loading="lazy"
            class="w-100"
          />
        </a>
      </template>
      <template v-if="isMobileScreenSize">
        <a :href="state.pdfLink" target="_blank">
          <img :src="data.winterBannerMobileImg" loading="lazy" class="w-100" />
        </a>
      </template>
    </div>
  </div>
</template>

<script>
import { checkIfStationPdfExists } from "@/stationPdf/checkIfStationPdfExits.js";
import summerBannerDesktopImg from "@/images/bannerDesktopSummer.png";
import summerBannerMobileImg from "@/images/bannerMobileSummer.png";
import winterBannerDesktopImg from "@/images/bannerDesktopWinter.png";
import winterBannerMobileImg from "@/images/bannerMobileWinter.png";

export default {
  name: "StationBanner",
  props: {
    parentStationId: String,
    stationId: String,
  },
  data() {
    return {
      state: {
        currentScreenSize: window.screenSizeManager.screenType,
        doesStationPdfExists: false,
        pdfLink: "",
      },
      data: {
        summerBannerDesktopImg,
        summerBannerMobileImg,
        winterBannerDesktopImg,
        winterBannerMobileImg,
      },
    };
  },
  computed: {
    isCurrentSeasonSummer() {
      return window.seasonManager.season === "E";
    },

    isTabletOrDesktopScreenSize() {
      return (
        this.state.currentScreenSize === "desktop" ||
        this.state.currentScreenSize === "tablet"
      );
    },

    isMobileScreenSize() {
      return this.state.currentScreenSize === "mobile";
    },
  },
  methods: {
    async getStationBannerPdf() {
      const parentStationId = this.parentStationId;
      const stationId = this.stationId;
      const isSummer = this.isCurrentSeasonSummer;

      const pdfContentLink = await checkIfStationPdfExists({
        stationId,
        parentStationId,
        isSummer,
      });

      if (pdfContentLink) {
        this.state.doesStationPdfExists = true;
        this.state.pdfLink = pdfContentLink;
      } else {
        this.state.doesStationPdfExists = false;
        this.state.pdfLink = '';
      }

      window.addEventListener("screenTypeChange", () => {
        const screenType = window.screenSizeManager.screenType;
        this.state.currentScreenSize = screenType;
      });
    },
  },
  async mounted() {
    await this.getStationBannerPdf();
  },
};
</script>

<style scoped>

img {
  box-shadow: 0px 0px 7px rgb(0 0 0 / 20%);
  border-radius: 20px;
}
</style>
